<template>
  <div class="physio_edit">
    <el-dialog
      title="编辑"
      :visible.sync="visible"
      width="440px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :before-close="close">
      <div class="content" v-loading="loading">
        <el-form ref="form" class="form" :model="form" :rules="rules" label-width="100px">
          <div class="form_item">
            <div class="form_item_label">货号：</div>
            <div class="form_item_value">{{form.artNo}}</div>
          </div>
          <div class="form_item">
            <div class="form_item_label">通用名称：</div>
            <div class="form_item_value">{{ form.physioCommonName}}</div>
          </div>
          <div class="form_item">
            <div class="form_item_label">单位：</div>
            <div class="form_item_value">{{form.unit}}</div>
          </div>
          <div class="form_item">
            <div class="form_item_label">医保编码：</div>
            <el-input v-model="form.dictDrugCode"></el-input>
          </div>
          <el-form-item label="商品名称：" prop="physioName">
            <el-input v-model.trim="form.physioName"></el-input>
          </el-form-item>
          <el-form-item label="执行模式：" prop="executionMode">
            <el-radio-group v-model="form.executionMode">
              <el-radio :label="10">按次执行</el-radio>
              <el-radio :label="20">按组执行</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="执行单位：" prop="perUnit">
            <el-radio-group v-model="form.perUnit" @change="changePerUnit">
              <el-radio :label="10">穴位</el-radio>
              <el-radio :label="20">部位</el-radio>
              <el-radio :label="30">不限制</el-radio>
            </el-radio-group>
            <div class="numberInput" v-show="form.perUnit == 10 || form.perUnit == 20">
              <div class="flex-sh">每{{ form.executionMode == 10 ? '次' : '组' }}</div>
              <el-input-number class="perUnitCount_input" v-model.trim="form.perUnitCount" :precision="0" :min="1"
                :max="999"></el-input-number>
              <div class="flex-sh">个{{ form.perUnit == 10 ? '穴位' : '部位' }}</div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="promtMap.visible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :before-close="promtClose">
      <div class="promt_content">
        <div class="promt_title">修改执行模式，对应的活动套餐将立即失效。</div>
        <div class="promt_list">
          <div class="promt_list_item" v-for="item in promtMap.list" :key="item.cseCode">
            <div class="promt_list_item_label">活动名称：</div>
            <div class="promt_list_item_name">{{ item.cseName }}</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="promtClose">
        <el-button @click="promtClose">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="promtSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isNull } from '@/utils/validateBase'
import { editPhysio } from '@/api/physio'
import { getProgressPhysioComboList } from '@/api/campaign'
export default {
  data() {
    return {
      visible: false,
      form: {},
      loading:false,
      rules: {
        physioName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
        ],
        executionMode: [
          { required: true, message: '请选择执行模式', trigger: 'change' },
        ],
        perUnit: [
          { required: true, message: '请选择执行单位', trigger: 'change' },
        ],
      },
      promtMap: {
        visible: false,
        list: []
      }
    }
  },
  methods: {
    changePerUnit(val) {
      if (isNull(val) || val == 30) {
        this.form.perUnitCount = ''
      }
    },
    close(){
      this.visible = false
      this.form = {}
    },
    open(info){
      const data = {...info,id:info.artNo}
      this.sourceData = JSON.parse(JSON.stringify(data))
      this.form = JSON.parse(JSON.stringify(data))
      this.visible = true
    },
    async updateData () {
      this.loading = true
      const res = await editPhysio(this.form)
      this.loading = false
      if (res.code === 200) {
        this.$message.success('保存成功')
        this.close()
        this.$parent.getList()
      }
    },
    submit () {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          if (this.form.executionMode !== this.sourceData.executionMode) {
            const comboRes = await getProgressPhysioComboList({ artNo: this.form.artNo })
            if (comboRes.code === 200 && (comboRes.data &&comboRes.data.length > 0)) {
              this.promtMap.list = comboRes.data
              this.promtMap.visible = true
            } else {
              this.updateData()
            }
          } else {
            this.updateData()
          }
        }
      })
    },
    promtClose () {
      this.promtMap.visible = false
      this.promtMap.list = []
    },
    promtSubmit () {
      this.promtClose()
      this.updateData()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-dialog__body{
  padding: 20px !important;
}
.form_item {
  height: 32px;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  margin-bottom: 16px;
}

.form_item_label {
  width: 100px;
  flex-shrink: 0;
  text-align: right;
}
/deep/.el-form-item__label{
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}
.numberInput{
  height: 44px;
  display: flex;
  align-items: center;
  background: #F7F8F9;
  padding: 0 12px;
}
.perUnitCount_input{
  width: 112px;
  margin: 0 12px;
  /deep/.el-input__inner{
    // width: 112px;
    padding: 0;
    padding-left: 12px;
    text-align: left;
  }
  /deep/.el-input-number__increase{
    display: none;
  }
  /deep/.el-input-number__decrease{
    display: none;
  }
}

.promt_content {
  width: 100%;
}

.promt_title {
 line-height: 24px;
 font-size: 16px;    
}

.promt_list {
  margin: 12px 0 0 0;
  width: 100%;
}

.promt_list_item {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.promt_list_item_label {
  flex-shrink: 0;
  line-height: 24px;
  font-size: 14px;
}

.promt_list_item_name {
  flex-grow: 1;
  line-height: 24px;
  font-size: 14px;
}
</style>